// const BASE_URL = "https://damusasa-sandbox.jiji.health/api/"; //Dev environment
const BASE_URL = "https://damusasa.jiji.health/api/"; //Live environment
// const BASE_URL = 'http://127.0.0.1:3000';

const getToken = () => localStorage.getItem('token');

const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json();
    // Throwing an error with a detailed message
    throw new Error(errorData.message || errorData.errors?.[0]);

  }
  return response.json();
};

const fetchApi = async (endpoint, method = 'GET', data) => {
  const token = getToken();
  const options = {
    method,

    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
    },
    ...(data && { body: JSON.stringify(data) }),
  };
  const response = await fetch(`${BASE_URL}/${endpoint}`, options);
  return handleResponse(response);
};

// CRUD operations
const create = (resource, data) => fetchApi(resource, 'POST', data);
const update = (resource, id, data) => fetchApi(`${resource}/${id}`, 'PATCH', data);
const get = (resource, id) => fetchApi(id ? `${resource}/${id}` : resource);
const remove = (resource, id) => fetchApi(`${resource}/${id}`, 'DELETE');

// API client object
const apiClient = {
  login: async (credentials) => {
    const response = await fetchApi('auth/login', 'POST', credentials);
    localStorage.setItem('token', response.token);
    localStorage.setItem('user', JSON.stringify(response.user));
    return response;
  },

  // Facilities management
  getFacilities: () => get('facilities'),
  getFacility: (id) => get('facilities', id),
  createFacility: (data) => create('facilities', data),

  getFacilityFeatures: (id) => get('account_features', id),
 
// Donor management
   getDonors: () => get('donors'),
   getDonor: (id) => get(`donors/${id}`),
   createDonor: (data) => create('donors', data),
   updateDonor: (id, data) => update('donors', id, data),
   deleteDonor: (id) => remove(`donors/${id}`),

   // Blood Groups
   getBloodGroups: () => get('blood_groups'),

// Region
   createCountry: (data) => create("countries", data),
   createCounty: (data) => create("counties", data),
   getCounty: (id) => get("counties", id),
   getRegions: () => get("regions"),
   updateCounty: (id, data) => update("counties", id, data),

   // Donor vitals
   createDonorVital: (donorId, data) =>
     create(`donors/${donorId}/donor_vitals`, { donor_vital: data }),

   // Apheresis SMS
   sendApheresisMessage: (data) => create("apheresis_messages", data),

};

export default apiClient;